import { ActionType } from "../actions/ActionTypes";
import { toast } from "react-toastify";

export interface StoryState {
  error: string;
  loading: boolean;
  singleStory: any;
  stories: any[];
  message: string;
  generate_loading: boolean;
  editLoading: boolean;
}

const initialState: StoryState = {
  error: "",
  loading: false,
  singleStory: {},
  stories: [],
  message: "",
  generate_loading: false,
  editLoading: false,
};

const reducer = (state: StoryState = initialState, action: any): any => {
  switch (action.type) {
    case ActionType.GENERATE_STORY_INIT:
      return {
        ...state,
        loading: true,
        error: "",
        message: "",
        generate_loading: true,
      };
    case ActionType.GENERATE_STORY_SUCCESS:
      toast.success(action.payload.message || "Story creation started");
      return {
        ...state,
        loading: false,
        message: action.payload.message,
        generate_loading: false,
      };
    case ActionType.GENERATE_STORY_FAIL:
      return {
        ...state,
        loading: false,
        generate_loading: false,
        error: action.payload,
      };

    case ActionType.CANCEL_STORY_INIT:
      return {
        ...state,
        loading: true,
        error: null,
        message: "",
      };
    case ActionType.CANCEL_STORY_SUCCESS:
      return {
        ...state,
        loading: false,
        message: action.payload.message,
      };
    case ActionType.CANCEL_STORY_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case ActionType.DELETE_STORY_INIT:
      return {
        ...state,
        error: "",
        loading: true,
      };

    case ActionType.DELETE_STORY_SUCCESS:
      return {
        ...state,
        error: "",
        loading: false,
      };

    case ActionType.DELETE_STORY_FAIL:
      return {
        ...state,
        error: action.payload,
        loading: false,
      };

    case ActionType.GET_SINGLE_STORY_INIT:
      return {
        ...state,
        error: "",
        loading: true,
      };

    case ActionType.GET_SINGLE_STORY_SUCCESS:
      return {
        ...state,
        error: "",
        loading: false,
        singleStory: action.payload,
      };

    case ActionType.GET_SINGLE_STORY_FAIL:
      return {
        ...state,
        error: action.payload,
        loading: false,
      };

    case ActionType.GET_ALL_STORY_INIT:
      return {
        ...state,
        error: "",
        loading: true,
      };

    case ActionType.GET_ALL_STORY_SUCCESS:
      return {
        ...state,
        error: "",
        loading: false,
        stories: action.payload,
      };

    case ActionType.GET_ALL_STORY_FAIL:
      return {
        ...state,
        error: action.payload,
        loading: false,
        stories: [],
      };
    case ActionType.EDIT_CAPTION_INIT:
      return {
        ...state,
        error: "",
        editLoading: true,
      };
    case ActionType.EDIT_CAPTION:
      return {
        ...state,
        editLoading: false,
        stories: state.stories.map((story: any) =>
          story.storyId === action.payload.storyId
            ? {
                ...story,
                content: story.content.map((slide: any) =>
                  slide.slideNumber === action.payload.slideNumber
                    ? { ...slide, caption: action.payload.newCaption }
                    : slide
                ),
              }
            : story
        ),
      };
    case ActionType.UPDATE_REGENERATED_CONTENT:
      return {
        ...state,
        editLoading: false,
        stories: state.stories.map((story: any) =>
          story.storyId === action.payload.storyId
            ? {
                ...story,
                content: action.payload.newContent,
              }
            : story
        ),
      };

    case ActionType.EDIT_CAPTION_FAIL:
      return {
        ...state,
        error: action.payload,
        editLoading: false,
      };
    case ActionType.RESET_STORY_MESSAGE:
      return {
        ...state,
        message: "",
      };

    case ActionType.APPROVE_REGENERATED_STORY_INIT:
      return {
        ...state,
        error: "",
        loading: true,
      };

    case ActionType.APPROVE_REGENERATED_STORY_SUCCESS:
      if (!action.payload?.storyId) {
        toast.success("Slide regeneration denied");
        return {
          ...state,
          loading: false,
          error: "",
        };
      }

      toast.success("Slide approved and story updated successfully.");
      return {
        ...state,
        error: "",
        loading: false,
        stories: state.stories.map((story: any) =>
          story.storyId === action.payload.storyId
            ? {
                ...story,
                content: story.content.map((slide: any) =>
                  slide.slideNumber === action.payload.slideIndex + 1
                    ? {
                        ...slide,
                        caption: action.payload.caption,
                        imageURL: action.payload.imageURL,
                      }
                    : slide
                ),
              }
            : story
        ),
      };

    case ActionType.APPROVE_REGENERATED_STORY_FAIL:
      return {
        ...state,
        error: action.payload,
        loading: false,
      };
    default:
      return state;
  }
};

export default reducer;
